import { render, staticRenderFns } from "./RenovationsData.vue?vue&type=template&id=d7cdaca2"
import script from "./RenovationsData.vue?vue&type=script&lang=js"
export * from "./RenovationsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports